import axios from "../axios";
import {
  MEAL_PACKAGES_API,
  SIGN_UP_USER_API,
  GENERATE_OTP_API,
  VERIFY_OTP_API,
  CHECKOUT_TRANSACTION_API,
  COUPON_DISCOUNT_API,
  ADD_DELIVERY_ADDRESS_API,
  CARD_UPDATE_API
} from "../../global/ApiUrl";

export const getPricePlans = async (requestParams) => {
  try {
    const response = await axios.get(MEAL_PACKAGES_API, {
      params: {
        ...requestParams,
      },
    });
    return response;
  } catch (error) {
    await console.log("getPricePlans catch error", error);
    return error;
  }
};

export const signupAPI = async (payload) => {
  try {
    const response = await axios.post(SIGN_UP_USER_API, payload);
    return response;
  } catch (error) {
    await console.log("signUpUser error-------------", error);
    return error;
  }
};

export const generateOtpAPI = async (email) => {
  try {
    const response = await axios.post(GENERATE_OTP_API, { email });
    return response;
  } catch (error) {
    await console.log("generateOtp error", error);
    return error;
  }
};

export const verifyOtpAPI = async (payload) => {
  try {
    const response = await axios.post(VERIFY_OTP_API, payload);
    return response;
  } catch (error) {
    await console.log("verifyOtpAPI error", error);
    return error;
  }
};

export const subscriptionTransactionAPI = async (payload) => {
  try {
    const response = await axios.post(CHECKOUT_TRANSACTION_API, payload);
    return response;
  } catch (error) {
    await console.log("verifyOtpAPI error", error);
    return error;
  }
};

export const cardUpdateAPI = async (payload) => {
  try {
    const response = await axios.post(CARD_UPDATE_API, payload);
    return response;
  } catch (error) {
    await console.log("Card update error", error);
    return error;
  }
};


export const promoCodeAPI = async (payload) => {
  try {
    const response = await axios.post(COUPON_DISCOUNT_API, payload);
    return response;
  } catch (error) {
    await console.log("verifyOtpAPI error", error);
    return error;
  }
};

// export const API_Call = async ({method= "get", url= null, data={}, params={} }) => {
//   const {method="get", url} = data
//   try {
//     const response = await axios({
//       method: "post",
//       url: "/user/12345",
//       data: {
//         firstName: "Fred",
//         lastName: "Flintstone",
//       },
//       params: {}
//     });

//   } catch (error) {

//   }
// }
